<template>
  <div class="animated fadeIn options-page">
    <v-card class="common-card">
      <div class="d-flex flex-row">
        <h4 class="c-grey pt-2 ps-2">تنظیمات</h4>
      </div>
      <hr class="mt-5" />
      <v-card class="text-center pb-12" v-if="isBusy">
        <cube></cube>
        <span style="font-size: 16px">در حال بارگذاری ...</span>
      </v-card>
      <v-card v-else flat>
        <div class="custom-table mt-3">
          <b-table
            responsive
            show-empty
            :items="optionsList"
            :fields="fields"
            empty-text="رکوردی برای نمایش وجود ندارد."
            striped
            class="middle"
            thead-class="headClass"
            tbody-class="bodyClass"
          >
            <template v-slot:empty>
              <div
                style="text-align: center; vertical-align: middle"
                class="pt-0"
              >
                رکوردی برای نمایش وجود ندارد.
              </div>
            </template>
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="text-align: center; vertical-align: middle"
                class="pt-3"
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(value)="data">
              <div style="text-align: center; vertical-align: middle;display:flex">
                <v-text-field
                  class="ms-2 me-2 mb-3 mt-1 pt-0 option-input"
                  outlined
                  dense
                  v-model="data.item.value"
                  hide-details
                  :type="data.item.enName == 'proformaExpireDate' ? 'number' : 'text'"
                ></v-text-field>
                <span class="mt-3 ms-1" v-if="data.item.enName == 'proformaExpireDate'">روز</span>
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div
                style="text-align: center; vertical-align: middle"
                class="pt-2"
              >
                <span v-show="false">{{ reactivity }}</span>
                <v-btn
                  class="purple-mainBtn"
                  width="130"
                  @click="editOption(data.item, data.index)"
                  :disabled="!optionsList[data.index].value"
                  :loading="loading[data.index]"
                  >اعمال تغییرات <v-icon class="ms-2">$Edit</v-icon></v-btn
                >
              </div>
            </template>
          </b-table>
        </div>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "name", label: "عنوان" },
        { key: "value", label: "مقدار" },
        { key: "operation", label: "عملیات" },
      ],
      optionsList: [],
      loading: [false, false],
      reactivity: false,
    };
  },
  methods: {
    getOptions() {
      this.isBusy = true;
      Axios.get(this.baseUrl + "/ppkpms/options/getOptions", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.isBusy = false;
            let options = res.data.shopOptions;
            for (let prop in options) {
              this.optionsList.push(options[prop] ? options[prop] : "");
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );

            this.toast(title, "error");
            this.isBusy = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    editOption(item, index) {
      this.loading[index] = true;
      this.reactivity = !this.reactivity;
      Axios.post(
        this.baseUrl + "/ppkpms/options/newOption",
        {
          key: item.enName,
          value: {
            name: item.name,
            enName: item.enName,
            value: item.value,
          },
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.loading[index] = false;
            this.reactivity = !this.reactivity;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.loading[index] = false;
            this.reactivity = !this.reactivity;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.loading[index] = false;
          this.reactivity = !this.reactivity;
        });
    },
  },
  mounted() {
    this.getOptions();
  },
};
</script>

<style lang="scss">
.options-page {
  .option-input {
    border-radius: 12px;
    background-color: #fff;
  }
  .custom-table .bodyClass tr td div {
    padding-top: 0;
  }
}
</style>
